


























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteCaixasCirurgicasStore from '@/components/Suporte/Store/SuporteCaixasCirurgicasStore'

@Component
export default class ComponentModalSuporteAdicionarCaixaCirurgica extends Vue {
  $refs!: { insertCaixaCirurgicaForm: any }

  loadCaixaCirurgica: boolean = false
  loadInsertCaixaCirurgica: boolean = false
  insertCaixaCirurgica: boolean = false
  caixaCirurgica: any = null

  insertCaixaCirurgicaForm: any = {
    valid: true,
    hisId: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  get getSuporteCaixasCirurgicasStore() {
    return getModule(SuporteCaixasCirurgicasStore, this.$store)
  }

  get showModalInsertCaixaCirurgica() {
    return this.insertCaixaCirurgica
  }

  set showModalInsertCaixaCirurgica(value: boolean) {
    this.insertCaixaCirurgica = value
  }

  get loadingCaixaCirurgica() {
    return this.loadCaixaCirurgica
  }

  set loadingCaixaCirurgica(value: boolean) {
    this.loadCaixaCirurgica = value
  }

  get loadingInsertCaixaCirurgica() {
    return this.loadInsertCaixaCirurgica
  }

  set loadingInsertCaixaCirurgica(value: boolean) {
    this.loadInsertCaixaCirurgica = value
  }

  get showModalCaixaCirurgica() {
    return this.getSuporteCaixasCirurgicasStore.modal.caixaCirurgica
  }

  set showModalCaixaCirurgica(value: boolean) {
    this.getSuporteCaixasCirurgicasStore.setModal({ name: 'caixaCirurgica', value })
  }

  get genericCaixasCirurgicas() {
    return this.getSuporteCaixasCirurgicasStore.genericCaixasCirurgicas
  }

  get caixasCirurgicasIds() {
    return this.getSuporteCaixasCirurgicasStore.caixasCirurgicas.map((c: any) => c.caixaCirurgicaId)
  }

  insert(item: any) {
    if (this.caixasCirurgicasIds.includes(item.id)) return
    this.caixaCirurgica = { caixaCirurgicaId: item.id, descricao: item.descricao, hisId: '' }
    this.showModalInsertCaixaCirurgica = true
  }

  async saveCaixaCirurgica() {
    this.loadingInsertCaixaCirurgica = true
    if (!this.$refs.insertCaixaCirurgicaForm.validate()) {
      this.loadingInsertCaixaCirurgica = false
      return
    }
    const response = await this.getSuporteCaixasCirurgicasStore.postCaixaCirurgicaToHospital(this.caixaCirurgica)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Caixa cirúrgica adicionada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.showModalInsertCaixaCirurgica = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
    }
    this.loadingInsertCaixaCirurgica = false
  }

  @Watch('showModalCaixaCirurgica')
  onChangeShowModalCaixaCirurgica(value: boolean) {
    if (!value) {
      this.getSuporteCaixasCirurgicasStore.clearGenericCaixasCirurgicas()
      this.getSuporteCaixasCirurgicasStore.setMode({ mode: 'CREATE' })
    }
  }

  @Watch('showModalInsertCaixaCirurgica')
  onChangeShowModalInsertCaixaCirurgica(value: boolean) {
    if (!value) {
      this.$refs.insertCaixaCirurgicaForm.resetValidation()
      this.caixaCirurgica = null
    }
  }
}
